define(function (require, exports) {
    'use strict';

    /** @type {ng.IAngularStatic} */
    var angular = require('angular');

    // The accordion directive simply sets up the directive controller
    // and adds an accordion CSS class to itself element.
    exports.metAccordion = function () {
        return {
            restrict: 'E',
            controller: 'MetAccordionController',
            controllerAs: 'accordion',
            transclude: true,
            link: function () {},
            template: '<div class="panel-group" ng-transclude></div>'
        };
    };

    // @ngInject
    exports.metAccordionGroup = function (metroTagging, metroMeta) {
        return {
            restrict: 'E',
            require: '^metAccordion', // We need this directive to be inside an accordion
            transclude: true,
            replace: true, // The element containing the directive will be replaced with the template
            link: function (scope, element, attrs, accordionCtrl) {

                accordionCtrl.addGroup(scope);

                scope.openClass = attrs.openClass || 'panel-open';
                scope.panelClass = attrs.panelClass || 'panel-met';

                scope.$watch('isOpen', function (value) {
                    element.toggleClass(scope.openClass, !!value);
                    if (value) {
                        accordionCtrl.closeOthers(scope);
                    }
                });

                scope.toggleOpen = function ($event) {
                    if (!scope.isDisabled) {
                        if (!$event || $event.which === 32) {
                            scope.isOpen = !scope.isOpen;
                        }
                    }
                };

                scope.signalOpened = function (obj) {
                    
                    /* GA Tagging COB-SCA-BA016*/
                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                        metroMeta.EVENTACTION.sca,
                        attrs.module +":"+ scope.heading,
                        metroMeta.EVENT.buttonAction);

                    if (scope.isOpen === true) {
                        scope.openAction(obj, scope.index);
                    }
                };
            },
            controller: function () {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            },
            scope: {
                heading: '@', // Interpolate the heading attribute onto this scope
                icon: '@',
                count: '@',
                isOpen: '=?',
                isDisabled: '=?',
                openAction: '&',
                showSwitcher: '@',
                index: '=?'
            },
            template: '<div class="panel" ng-class="panelClass || \'panel-met\'">' +
                '   <div class="panel-heading" ng-keypress="toggleOpen($event)">' +
                '       <div class="panel-title">' +
                '           <div tabindex="0" class="accordion-toggle" ng-click="toggleOpen(); signalOpened(this)" met-accordion-transclude="heading">' +
                '               <span ng-class="{\'text-muted\': isDisabled}"><span ng-if="icon"><i class="fa fa-{{icon}}"></i></span> ' +
                '               <h4>{{heading}} <span class="badge badge-important" ng-show="count" ng-bind="count">  </h4></span><span ng-show="showSwitcher" class="accordion-switcher"><i class="fa" ng-class="{\'fa-caret-down fa-lg\': isOpen, \'fa-caret-right fa-lg\': !isOpen}"></i></span>' +
                '           </div>' +
                '       </div>' +
                '   </div>' +
                '   <div class="panel-collapse" ng-class="{collapse: isOpen == false}">' +
                '       <div class="panel-body" ng-transclude></div>' +
                '   </div>' +
                '</div>'
        };
    };

    // Use accordion-heading below an accordion-group to provide a heading containing HTML
    exports.metAccordionHeading = function () {
        return {
            transclude: true, // Grab the contents to be used as the heading
            template: '', // In effect remove this element!
            replace: true,
            require: '^metAccordionGroup',
            link: function (scope, element, attrs, accordionGroupCtrl, transclude) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
            }
        };
    };

    // Use in the accordion-group template to indicate where you want the heading to be transcluded
    // You must provide the property on the accordion-group controller that will hold the transcluded element
    exports.metAccordionTransclude = function () {
        return {
            require: '^metAccordionGroup',
            link: function (scope, element, attrs, controller) {
                scope.$watch(function () {
                    return controller[attrs.metAccordionTransclude];
                }, function (heading) {
                    if (heading) {
                        element.find('span').html('');
                        element.find('span').append(heading);
                    }
                });
            }
        };
    };

});



// WEBPACK FOOTER //
// ./scripts/directives/metAccordion/metAccordion.js